<template>
    <div class="TopicRoutesContainer">
        <div class="btn-position-wrap">
            <md-tabs class="md-tabs-wrapper container" md-sync-route md-alignment="left">
                <md-tab md-label="Topics" to="/tour/topicRoutes/topics"/>
                <md-tab md-label="Routes" to="/tour/topicRoutes/routes"/>
            </md-tabs>
        </div>
        <hr/>
        <router-view></router-view>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('tours', ['currentTour'])
  },
  methods: {
    ...mapActions('topics', ['loadTopics']),
    ...mapActions('routes', ['loadRoutes', 'clearCurrentRoute'])
  },
  mounted () {
    this.loadRoutes(this.currentTour.id);
    this.loadTopics(this.currentTour.id);
    this.clearCurrentRoute();
  }
};
</script>
<style lang="scss">
.TopicRoutesContainer .container {
    padding: 0px !important;
}

.TopicRoutesContainer .md-tabs .md-button {
    width: 172px !important;
}

.TopicRoutesContainer {
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/TopicRouteTabs.vue